import { axiosRequest, updateHeaders } from '@/plugins/axios-common'

import { LastLoginInfoActions } from './partials/LastLoginInfo'

export const AuthenticationActions = {
  ...LastLoginInfoActions,

  handleSuccessfulAuthentication ({ commit, dispatch }, response) {
    const token = response.access_token
    const user = response.user

    if (user?.reset_required) return { user: user }

    updateHeaders(token)

    commit('authSuccess', token, { root: true })
    commit('setRefreshTokenExpiresAt', response.refresh_token_expires_at, { root: true })
    commit('setCurrentUser', user, { root: true })
    dispatch('updateLastLoginInfo', response.last_login)

    if (response.redirect_to) window.sessionStorage.setItem('returnTo', response.redirect_to)
  },

  loadMultifactorAuthenticationSettings ({ getters, commit }) {
    return axiosRequest.get('/auth/settings').
      then(({ data }) => {
        commit('setMultifactorAuthenticationSettings', data)
      })
  },

  requestAuthentication ({ dispatch }, { username, password, strategy, redirectTo }) {
    return axiosRequest.post('/auth/request', { username, password, redirectTo, strategy }).
      then(({ data }) => {
        if (strategy === 'none' && data?.access_token) {
          return dispatch('handleSuccessfulAuthentication', data)
        } else {
          return data
        }
      }).
      catch(error => { throw error.response })
  },

  verifyAuthenticationRequest ({ dispatch }, { strategy, passcode }) {
    return axiosRequest.post('/auth/verify', { strategy, passcode }).
      then(({ data }) => dispatch('handleSuccessfulAuthentication', data))
  },
}
